var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeliIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M18 0C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6C0 2.68629 2.68629 0 6 0H18Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.1671C16.5386 17.1671 19.8125 14.9882 19.8125 12.3003C19.8125 9.61251 16.5386 7.43359 12.5 7.43359C8.46142 7.43359 5.1875 9.61251 5.1875 12.3003C5.1875 14.9882 8.46142 17.1671 12.5 17.1671Z",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13867 9.125C7.89421 9.48523 8.7028 9.7215 9.53342 9.82475C10.1099 9.78548 10.6811 9.68836 11.2382 9.53487",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0811 9.15642C17.5115 9.54419 16.8327 9.73935 16.1442 9.7133C14.8936 9.7133 13.8098 8.88867 12.6886 8.88867C11.6881 8.88867 9.99268 10.5285 9.99268 10.8252C9.99268 11.1218 10.4839 11.2977 10.8822 11.1027C11.1151 10.989 12.1234 10.0099 12.9387 10.0099C13.7539 10.0099 16.3958 12.6859 16.6351 12.9372C17.0059 13.3264 16.2878 14.1649 15.8292 13.7059C15.3706 13.2469 14.5504 12.5202 14.5504 12.5202",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7751 11.8086C18.6528 11.9409 17.5655 12.2834 16.57 12.8181M15.7176 13.5985C16.0885 13.9873 15.3703 14.8258 14.9117 14.3672C14.4531 13.9086 13.9438 13.4248 13.9438 13.4248",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.801 14.2578C15.1715 14.6467 14.4534 15.4852 13.9947 15.0266C13.5361 14.5679 13.2354 14.2908 13.2354 14.2908",
    stroke: "#FEC53D",
    strokeWidth: 0.321429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5752 15.0424C12.6614 15.1427 12.7694 15.2219 12.8909 15.274C13.0124 15.3261 13.1442 15.3497 13.2763 15.343C13.4083 15.3362 13.5371 15.2993 13.6527 15.2352C13.7683 15.171 13.8677 15.0812 13.9432 14.9727",
    stroke: "#FEC53D",
    strokeWidth: 0.321429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5755 15.0445C12.7743 14.7831 12.7593 13.8512 11.734 14.0365C11.9748 13.5793 11.7588 12.8567 10.8385 13.2827C10.824 13.1497 10.7679 13.0247 10.678 12.9256C10.5881 12.8265 10.4692 12.7584 10.3382 12.731C10.2073 12.7036 10.071 12.7184 9.94899 12.7731C9.82693 12.8279 9.72535 12.9199 9.65878 13.036C9.63983 12.917 9.58201 12.8076 9.49436 12.7249C9.4067 12.6422 9.29414 12.5909 9.17424 12.5789C9.05434 12.5669 8.93384 12.5949 8.83154 12.6586C8.72925 12.7223 8.65092 12.8181 8.60878 12.931C8.40478 13.345 8.71978 14.092 9.39328 13.672C9.32503 14.401 9.70828 14.6233 10.3998 14.3395C10.4369 15.0557 10.9124 14.9938 11.2522 14.827C11.2852 14.9665 11.3588 15.093 11.4637 15.1908C11.5685 15.2886 11.7 15.3531 11.8414 15.3764C11.9829 15.3996 12.1281 15.3805 12.2587 15.3215C12.3893 15.2624 12.4995 15.166 12.5755 15.0445Z",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25146 11.6562C6.47165 11.7478 7.64518 12.1639 8.65046 12.8615",
    stroke: "#FEC53D",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeliIcon);
export default __webpack_public_path__ + "static/media/meli-icon.4bb6cbe746b99ff35c57a93f1b8e8a97.svg";
export { ForwardRef as ReactComponent };